import React from 'react';
interface Column<T> {
  key: keyof T | string;
  header: string;
  width?: string;
  render?: (row: T) => React.ReactNode;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  onRowClick?: (row: T) => void;
  emptyMessage?: string;
}
export function Table<T extends {
  id: string | number;
}>({
  columns,
  data,
  onRowClick,
  emptyMessage = 'No data available'
}: TableProps<T>) {
  return <div className="overflow-x-auto" data-id="element-643">
      <table className="w-full text-sm" data-id="element-644">
        <thead data-id="element-645">
          <tr className="border-b border-slate-200 dark:border-slate-800" data-id="element-646">
            {columns.map(column => <th key={String(column.key)} className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider" style={{
            width: column.width
          }} data-id="element-647">
                {column.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-800" data-id="element-648">
          {data.length === 0 ? <tr data-id="element-649">
              <td colSpan={columns.length} className="px-4 py-8 text-center text-slate-500 dark:text-slate-400" data-id="element-650">
                {emptyMessage}
              </td>
            </tr> : data.map((row, index) => <tr key={row.id} onClick={() => onRowClick?.(row)} className={`
                  ${index % 2 === 0 ? 'bg-white dark:bg-slate-900' : 'bg-slate-50/50 dark:bg-slate-800/30'}
                  ${onRowClick ? 'cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800' : ''}
                  transition-colors
                `} data-id="element-651">
                {columns.map(column => <td key={String(column.key)} className="px-4 py-3 text-slate-900 dark:text-slate-100" data-id="element-652">
                    {column.render ? column.render(row) : String(row[column.key as keyof T] ?? '')}
                  </td>)}
              </tr>)}
        </tbody>
      </table>
    </div>;
}